import { Typography, TypographyVariants, TypographyColors, Badge } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { cx } from '@/lib/utils';
import styles from './DiscrepancyDetailCard.module.scss';

// A label/value pair — or, for type: 'status', a colored dot badge.
const DiscrepancyField = ({ label, value, type, tone }) => {
  const t = useTranslations();
  return (
    <div className={styles.field}>
      <Typography variant={TypographyVariants.caption} color={TypographyColors.placeholder}>
        {label}
      </Typography>
      {type === 'status' ? (
        <Badge variant={tone} withDot>
          {value}
        </Badge>
      ) : (
        <Typography variant={TypographyVariants.bodyXs}>
          {value ?? t('DISCREPANCY_EMPTY_VALUE')}
        </Typography>
      )}
    </div>
  );
};

// Section caption + divider, then a 2-column grid (column-major fill, any field count).
const DiscrepancySection = ({ title, fields }) => (
  <div className={styles.section}>
    <div className={styles.sectionHeader}>
      <Typography
        variant={TypographyVariants.caption}
        color={TypographyColors.placeholder}
        className={styles.sectionTitle}
      >
        {title}
      </Typography>
      <div className={styles.sectionLine} />
    </div>
    <div className={styles.grid} style={{ '--rows': Math.ceil(fields.length / 2) }}>
      {fields.map((field) => (
        <DiscrepancyField
          key={field.label}
          label={field.label}
          value={field.value}
          type={field.type}
          tone={field.tone}
        />
      ))}
    </div>
  </div>
);

/**
 * Props:
 *   sections   [{ title, fields: [{ label, value }] }]
 *   className  layout hook for the caller
 */
export const DiscrepancyDetailCard = ({ sections, className }) => (
  <div className={cx(styles.card, className)}>
    {sections.map((section) => (
      <DiscrepancySection key={section.title} title={section.title} fields={section.fields} />
    ))}
  </div>
);
